<ng-container *ngIf="field?.unit; else Field">
  <ion-row>
    <ion-col class="ion-no-padding">
      <ng-container [ngTemplateOutlet]="Field"></ng-container>
    </ion-col>
    <ion-col size="auto" class="ion-align-self-center">
      <div style="margin-left: 8px; margin-right: 8px;">
        {{ field?.unit }}
      </div>
    </ion-col>
  </ion-row>
</ng-container>
<!-- <ng-template #Field>
  <ion-item
    [disabled]="disabledField"
    [ngClass]="{
      'gl-disable-invisible': disabledField && !looksDisabled,
      'item-disabled': field.readonly
    }"
  >
    <ion-label
      [color]="cFormControl.dirty && cFormControl.invalid ? 'danger' : undefined"
      *ngIf="!noLabel"
    >
      {{ field.label }}
    </ion-label>

    Si champ readonly OU disabled => afficher displayedValue
    <ng-container *ngIf="(disabledField || field.readonly) && field.subType === 'input-number'; else EditableInput">
      <ion-text class="gl-input-highlight" slot="end">{{ displayedValue }}</ion-text>
    </ng-container>

    Sinon, input classique
    <ng-template #EditableInput>
      <ng-container *ngIf="noLabel; else SlotEnd">
        <ion-input
          class="gl-input-highlight"
          [formControl]="cFormControl"
          [type]="field.subType === 'input-number' ? 'number' : 'text'"
          [readonly]="field.readonly"
          [debounce]="500"
        ></ion-input>
      </ng-container>

      <ng-template #SlotEnd>
        <ion-input
          slot="end"
          class="gl-input-highlight"
          [formControl]="cFormControl"
          [type]="field.subType === 'input-number' ? 'number' : 'text'"
          [readonly]="field.readonly"
          [debounce]="500"
        ></ion-input>
      </ng-template>
    </ng-template>
  </ion-item>
</ng-template> -->
<ng-template #Field>
  <ion-item [disabled]="disabledField" [ngClass]="{'gl-disable-invisible': disabledField && !looksDisabled, 'item-disabled': (field.readonly ?? 0) | readonlyByRule: etatId}">
    <!-- <ion-label [color]="(cFormControl.dirty && cFormControl.invalid && !((field.readonly ?? 0) | readonlyByRule: etatId)) ? 'danger' : undefined" *ngIf="!noLabel">{{ field.label }}</ion-label> -->
    <ion-label [color]="(cFormControl.dirty && cFormControl.invalid) ? 'danger' : undefined" *ngIf="!noLabel">{{ field.label }}</ion-label>
    <ng-container *ngIf="(disabledField || ((field.readonly ?? 0) | readonlyByRule: etatId)) && field.subType === 'input-number'; else EditableField">
      <ion-text class="gl-input-highlight" [attr.slot]="noLabel ? null : 'end'">{{ displayedValue }}</ion-text>
    </ng-container>
    <ng-template #EditableField>
      <ng-container *ngIf="noLabel; else SlotEnd">
        <ion-input class="gl-input-highlight"
        [formControl]="cFormControl"
        [type]="field.subType === 'input-number' ? 'number' : 'text'"
        [readonly]="(field.readonly ?? 0) | readonlyByRule: etatId"
        [debounce]="3000"
        (ionBlur)="field.subType === 'input-number' && normalizeNumberValue()"></ion-input>
      </ng-container>
      <ng-template #SlotEnd>
        <ion-input slot="end" class="gl-input-highlight"
        [formControl]="cFormControl"
        [type]="field.subType === 'input-number' ? 'number' : 'text'"
        [readonly]="(field.readonly ?? 0) | readonlyByRule: etatId"
        [debounce]="3000"
        (ionBlur)="field.subType === 'input-number' && normalizeNumberValue()"></ion-input>
      </ng-template>
    </ng-template>
  </ion-item>
  <!-- <ion-row *ngIf="cFormControl.invalid && !disabledField && !((field.readonly ?? 0) | readonlyByRule: etatId) && cFormControl.errors && cFormControl.errors['err'] as err" class="ion-margin-end c-inputtext-error-row"> -->
  <ion-row *ngIf="cFormControl.invalid && !disabledField && cFormControl.errors && cFormControl.errors['err'] as err" class="ion-margin-end c-inputtext-error-row">

    <ion-col size="12" class="ion-no-padding" *ngIf="err?.text">
      <div class="c-inputtext-error-banner">
        <ion-text>{{ err?.text }}</ion-text>
      </div>
    </ion-col>
  </ion-row>

</ng-template>